import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import noTranslations from './locales/no/translation.json';
import enTranslations from './locales/en/translation.json';

const LANGUAGE_KEY = 'trustpulse_language';

// Safe localStorage wrapper to handle SSR, tests, and disabled localStorage
const safeLocalStorage = {
  getItem: (key: string): string | null => {
    try {
      return typeof window !== 'undefined' ? localStorage.getItem(key) : null;
    } catch {
      return null;
    }
  },
  setItem: (key: string, value: string): void => {
    try {
      if (typeof window !== 'undefined') {
        localStorage.setItem(key, value);
      }
    } catch {
      // Silent fail - localStorage might be disabled
    }
  }
};

// Get saved language from localStorage or use default
const getSavedLanguage = (): string => {
  const saved = safeLocalStorage.getItem(LANGUAGE_KEY);
  return saved || 'no';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      no: {
        translation: noTranslations,
      },
      en: {
        translation: enTranslations,
      },
    },
    lng: getSavedLanguage(),
    fallbackLng: 'no',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false, // Prevent showing translation keys while loading
    },
  });

// Save language to localStorage when it changes
i18n.on('languageChanged', (lng) => {
  safeLocalStorage.setItem(LANGUAGE_KEY, lng);
});

export default i18n;
